import merge from "lodash.merge";
import appEventData from "./appEventData";

type AnalyticPageType = {
  baseURL?: string;
  channel?: string;
  navigationPath?: string | null;
  pageName?: string;
  siteAudience?: string;
  siteCountry?: string;
  siteLanguage?: string;
  siteSection1?: string;
  siteSection2?: string;
  siteSection3?: string;
  siteSection4?: string;
  webPageType?: string;
};

type AnalyticUserType = {
  advisorId?: string;
  dealerCode?: string;
  institutionalID?: string;
  institutionalPartyId?: string;
  investorId?: string;
  partyId?: string;
  pcsSfmcId?: string;
  personaSegment?: string;
  planId?: string;
  planParticipantId?: string;
  tracSponsorId?: string;
  userRole?: string;
  visionId?: string;
};

type AnalyticPageLoadStartedType = {
  event: string;
  page: AnalyticPageType;
  user: AnalyticUserType;
};

export type PartialAnalyticPageLoadStartedType =
  Partial<AnalyticPageLoadStartedType>;

const getPageName = (pathName: string) => {
  let directories = pathName.replace(/\/$/, "").split("/");

  if (directories.length > 2) {
    directories = directories.slice(-2);
  }

  return directories.join(" > ");
};

const defaultPageLoadedStartedEventConfig: AnalyticPageLoadStartedType = {
  event: "Page Load Started",
  page: {
    baseURL: window.location.origin,
    channel: "US Sites",
    navigationPath: "",
    pageName: getPageName(window.location.pathname),
    siteAudience: "institutional",
    siteCountry: "us",
    siteLanguage: "en",
    siteSection1: "",
    siteSection2: "",
    siteSection3: "",
    siteSection4: "",
    webPageType: "SPA",
  },
  user: {
    advisorId: "",
    dealerCode: "",
    institutionalID: "",
    institutionalPartyId: "",
    investorId: "",
    partyId: "",
    personaSegment: "",
    planId: "",
    planParticipantId: "",
    tracSponsorId: "",
    userRole: "",
    visionId: "",
  },
};

const pageLoadStartedEvent = (
  pageLoadStartedEvent: PartialAnalyticPageLoadStartedType = {},
) => {
  const config = merge(
    defaultPageLoadedStartedEventConfig,
    pageLoadStartedEvent,
  );
  appEventData.push(config);
};

export default pageLoadStartedEvent;
